import { ModelAnswerPageStatePresenter } from '@/presentation/presenters/modelAnswer/modelAnswerPageStatePresenter'
import { ModelAnswerPageStateViewModel } from '@/presentation/viewmodels/modelAnswer/modelAnswerPageStateViewModel'

export function useModelAnswerPageStatePresenter(
  presenter: ModelAnswerPageStatePresenter = new ModelAnswerPageStatePresenter(new ModelAnswerPageStateViewModel())
) {
  return {
    modelAnswerExpandedList: presenter.modelAnswerExpandedList,
    modelAnswerLoadingList: presenter.modelAnswerLoadingList,
    modelAnswerIsDiffList: presenter.modelAnswerIsDiffList,
    pageIndex: presenter.pageIndex,
    isFirstOpendPage: presenter.isFirstOpendPage,
    isNotMoreModelAnswerList: presenter.isNotMoreModelAnswerList,
    hasDataInExpandedList: presenter.hasDataInExpandedList.bind(presenter),
    hasDataInLoadingList: presenter.hasDataInLoadingList.bind(presenter),
    setPageIndex: presenter.setPageIndex.bind(presenter),
    setIsFirstOpendPage: presenter.setIsFirstOpendPage.bind(presenter),
    reverseModelAnswerIsDiffFlag: presenter.reverseModelAnswerIsDiffFlag.bind(presenter)
  }
}
